module.exports = __webpack_public_path__ + "static/media/placeholder-episodes.e616b2d9.gif";